
{
  "labels": {
    "date": "Date",
    "time": "Time",
    "subject": "Subject"
  }
}
